import { useUser } from 'src/utils/authentication';
import { isConcierge } from 'src/utils/permissions';

export default function useIsCompanyMember(companyUuid) {
  const { data: user } = useUser();

  return user?.company?.uuid === companyUuid || isConcierge(user);
}
